// The set of theme modes the app supports, and the labels the theme switcher
// shows for them. Driving the switcher's UI off this array (rather than
// hardcoded JSX branches per mode) means a future mode can be added here
// alone — see `components/app-shell/theme-toggle`.
export type ThemeMode = "system" | "light" | "dark";

export type ThemeModeOption = {
  value: ThemeMode;
  label: string;
};

export const THEME_MODE_OPTIONS: ThemeModeOption[] = [
  { value: "system", label: "System" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
];

// "light" — not "system" — because nazare-frontend's production app has no
// dark mode wired today (it's always light regardless of OS preference);
// defaulting a brand-new consumer to "system" would make it silently diverge
// from the rest of the product on any machine with a dark OS preference.
export const DEFAULT_THEME_MODE: ThemeMode = "light";

export function isThemeMode(value: unknown): value is ThemeMode {
  return THEME_MODE_OPTIONS.some((option) => option.value === value);
}
